// extracted by mini-css-extract-plugin
export default {"artwork":"herosectionartwork_artwork__xEiyr","secondMonument":"herosectionartwork_secondMonument__L0oPW"};